/**
 * AJAX Product Filtering and Loading Script
 *
 * This script manages the filtering, searching, and loading of products in an e-commerce environment.
 * It utilizes AJAX requests to dynamically fetch and display products based on user interactions,
 * including filtering by taxonomy, searching by keywords, and sorting by various criteria.
 *
 * Key Features:
 * - Loads more products when the "Load More" button is clicked.
 * - Filters products based on selected taxonomy terms.
 * - Allows searching by keywords.
 * - Resets all filters when the "Clear Filters" button is clicked.
 * - Sorts products based on user-selected criteria.
 */
(() => {
	if (typeof product_data !== 'undefined' && product_data.products_per_page) {
		let paged = 2;
		const productsPerPage = parseInt(product_data.products_per_page);
		let totalProducts = parseInt(product_data.total_products);
		let productsShown = productsPerPage;
		let activeFilters = {};
		let sortOrder = 'date'; // Default sorting by date (new to old)
		let filterNonce = document.getElementById('filter_nonce').value;
		let currentSearchKeyword = '';
		const productGrid = $('.product-grid');
		const btnLoadMore = $('.btn-load-more');

		// Update products list
		function updateProducts(resetPaging = false, searchKeyword = '') {
			if (resetPaging) {
				paged = 1;
				productsShown = 0;
				productGrid.html(''); // Reset product grid
			}

			$.ajax({
				url: product_data.ajax_url,
				type: 'POST',
				data: {
					action: 'load_more_products',
					paged: paged,
					filters: activeFilters,
					orderby: sortOrder, // Send sort order to AJAX
					search: searchKeyword, // Include search keyword
					filterNonce: filterNonce
				},
				beforeSend: function () {
					btnLoadMore.show();
					btnLoadMore.text('Loading...').prop('disabled', true);
				},
				dataType: 'json',
				success: function (data) {
					if (data.products) {
						if (resetPaging) {
							productGrid.html(data.products);
						} else {
							productGrid.append(data.products);
						}
						observeInviewElements(productGrid[0]);
						productsShown += productsPerPage;
						paged++;

						// Update totalProducts based on the response
						totalProducts = data.total_products;

						// Check if there are more products to load
						if (productsShown < totalProducts) {
							btnLoadMore
								.text('Load More')
								.prop('disabled', false);
						} else {
							btnLoadMore
								.text('No more courses')
								.prop('disabled', true);
						}
					} else {
						btnLoadMore
							.text('No more courses')
							.prop('disabled', true);
					}
				},
				error: function () {
					btnLoadMore.text('Load More').prop('disabled', false);
				}
			});
		}

		// Search
		$('form#search-form').on('submit', function (e) {
			e.preventDefault(); // Prevent default form submission

			// Get the search keyword
			const searchKeyword = $(this).find('input[type="text"]').val();

			// ✅ Store it for use in other filters
			currentSearchKeyword = searchKeyword;

			// Update products with the search keyword
			updateProducts(true, searchKeyword);
		});

		const btnClearSearch = $('.btn-clear-search');
		const searchInput = $('form#search-form input[type="text"]');

		// Show/hide clear button based on input value
		searchInput.on('input', function () {
			if ($(this).val().length > 0) {
				btnClearSearch.show();
			} else {
				btnClearSearch.hide();
			}
		});

		// Clear search when button is clicked
		btnClearSearch.on('click', function () {
			searchInput.val('');
			$(this).hide();
			currentSearchKeyword = '';
			updateProducts(true, '');
		});

		// Delivery Type Filter (single-select button group with "All" logic)
		$('.list-delivery-type button').on('click', function () {
			const $this = $(this);
			const term = $this.data('term');
			const taxonomy = $this.data('taxonomy');

			// Remove js-active from all delivery type buttons
			$('.list-delivery-type button').removeClass('js-active');

			// Add js-active to the clicked one
			$this.addClass('js-active');

			if (term === '*') {
				// "All" clicked: remove delivery_type filter entirely
				delete activeFilters[taxonomy];
			} else {
				// Apply selected delivery_type filter
				activeFilters[taxonomy] = [term];
			}

			// Refresh product list
			updateProducts(true, currentSearchKeyword);
		});

		// Clear all filters when the clear filters button is clicked
		$('.btn-clear-filters').on('click', function () {
			// Remove active state from all taxonomy filter buttons
			$('.list-terms button').removeClass('js-active');

			// Remove active state from all delivery type buttons
			$('.list-delivery-type button').removeClass('js-active');

			// ✅ Re-activate the "All" delivery type button
			$('.list-delivery-type button[data-term="*"]').addClass(
				'js-active'
			);

			// Clear active filters and search
			activeFilters = {};
			currentSearchKeyword = '';
			$('form#search-form input[type="text"]').val('');
			$('.btn-clear-search').hide();

			// Refresh products with no filters
			updateProducts(true, currentSearchKeyword);
		});

		// Load more products on button click
		btnLoadMore.on('click', function (e) {
			e.preventDefault();
			updateProducts();
		});

		// Filter products by taxonomy, including "All" filter functionality
		$('.list-terms button').on('click', function () {
			const $this = $(this);
			const taxonomy = $this.data('taxonomy');
			const term = $this.data('term');

			// Check if the clicked button is the "All" filter
			if (term === '*') {
				const allFilter = $this;
				const filterButtons = $(
					`button[data-taxonomy="${taxonomy}"]:not([data-term="*"])`
				);

				// If "All" is not active
				if (!allFilter.hasClass('js-active')) {
					// Add js-active class to all filters with the same taxonomy
					filterButtons.addClass('js-active');

					// Add js-active class to "All"
					allFilter.addClass('js-active');

					// Activate all filters for this taxonomy
					activeFilters[taxonomy] = filterButtons
						.map(function () {
							return $(this).data('term');
						})
						.get();
				} else {
					// If "All" is active, remove js-active class from all filters
					filterButtons.removeClass('js-active');

					// Remove js-active class from "All"
					allFilter.removeClass('js-active');

					// Deactivate all filters for this taxonomy
					delete activeFilters[taxonomy];
				}
			} else {
				// If a specific filter is clicked (not "All"), toggle its js-active class
				$this.toggleClass('js-active');

				// Remove "All" filter active state if a specific filter is selected
				$(
					`button[data-taxonomy="${taxonomy}"][data-term="*"]`
				).removeClass('js-active');

				// Activate or deactivate the specific term in the filter
				if ($this.hasClass('js-active')) {
					if (!activeFilters[taxonomy]) {
						activeFilters[taxonomy] = [];
					}
					activeFilters[taxonomy].push(term);
				} else {
					activeFilters[taxonomy] = activeFilters[taxonomy].filter(
						t => t !== term
					);
					if (activeFilters[taxonomy].length === 0) {
						delete activeFilters[taxonomy];
					}
				}
			}

			// Add or remove the applied filter pill (only for specific filters)
			const appliedFiltersList = $('.applied-filters');

			// Only run for specific filters, not "All"
			if (term !== '*') {
				const filterKey = `[data-taxonomy="${taxonomy}"][data-term="${term}"]`;

				if ($this.hasClass('js-active')) {
					console.log('has js-active');
					// Create and append the filter pill if it doesn't already exist
					if (
						appliedFiltersList.find(`li${filterKey}`).length === 0
					) {
						const pill = $(` <li>
							<button type="button" class="applied-filter btn-reset" data-taxonomy="${taxonomy}" data-term="${term}">
								${$this.text()} <span class="remove">×</span>
							</button>
						</li>`);

						appliedFiltersList.append(pill);
					}
				} else {
					// Remove the pill if the filter is deactivated
					console.log('NOI js-active');
					appliedFiltersList
						.find(`button${filterKey}`)
						.closest('li')
						.remove();
				}
			}

			// Update the products with the new filter state
			updateProducts(true, currentSearchKeyword);
		});

		// Handle click on applied filter pills
		$('.applied-filters').on('click', '.applied-filter', function () {
			const $pill = $(this);
			const taxonomy = $pill.data('taxonomy');
			const term = $pill.data('term');

			// Trigger click on the matching list-terms button
			$(
				`.list-terms button[data-taxonomy="${taxonomy}"][data-term="${term}"]`
			).trigger('click');

			// Remove the pill from the DOM
			$pill.closest('li').remove();
		});

		// Sort products when sort option is selected
		$('.sort-dropdown button').on('click', function () {
			const $this = $(this);
			const sortData = $this.data('order');

			// Remove js-active from all sort buttons and the trigger
			$('.sort-dropdown button').removeClass('js-active');
			$('.sort-dropdown').removeClass('js-active');
			$('.sort-trigger').removeClass('js-active');

			// Add js-active to the clicked button and the sort trigger
			$this.addClass('js-active');

			// Update sortOrder based on selected sort option
			if ('desc' === sortData) {
				sortOrder = 'date';
			} else if ('asc' === sortData) {
				sortOrder = 'date_asc';
			}

			// Reset products and update with new sort order
			updateProducts(true, currentSearchKeyword);
		});
	}
})();
